export default __webpack_public_path__ + "static/media/10.08ab957d.png";